import { render } from "./MyHomePageHeader.vue?vue&type=template&id=5309444c&scoped=true"
import script from "./MyHomePageHeader.vue?vue&type=script&lang=js"
export * from "./MyHomePageHeader.vue?vue&type=script&lang=js"

import "./MyHomePageHeader.vue?vue&type=style&index=0&id=5309444c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5309444c"]])

export default __exports__